module.exports = __webpack_public_path__ + "static/media/pajero-hero.8cf67339.jpg";